/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxOverviewStudentController", function OverviewStudentController(
	$scope,
	$filter,
	$window,
	$location,
	$cookies,

	examStatus,
	examState,
	dxSession,
	dxApiV1Students,
	dxApiV1Session
) {
	"use strict";

	var chromeRegex = new RegExp(/\bCrOS\b/);
	var role = dxSession.getRole();

	$scope.isChromeOS = chromeRegex.test($window.navigator.userAgent);
	$scope.exams = [];
	$scope.organizationName = role.organizationTitle;

	dxApiV1Students.examList(-1 * role.id).then(function setExams(exams) {
		$scope.exams = exams || [];
	});

	$scope.filterPublished = function filterPublished(exam) {
		return exam.state === examState.FINAL && exam.status === examStatus.PUBLISHED;
	};

	$scope.filterNotPublished = function filterNotPublished(exam) {
		return exam.state === examState.FINAL && exam.status !== examStatus.PUBLISHED;
	};

	$scope.filterNotHandedIn = function filterNotHandedIn(exam) {
		return exam.state !== examState.FINAL;
	};

	$scope.formatDate = function formatDate(dateString) {
		var date = new Date(dateString);

		if (date.getFullYear() === 1) {
			return "--";
		}
		return $filter("date")(date, "yyyy-MM-dd HH:mm");
	};

	$scope.openClient = function openClient() {
		var region = "europe";
		switch ($location.host()) {
			case "digiexam-live.appspot.com":
			case "app.digiexam.com":
				region = "europe";
				break;
			case "digiexam-live-us.appspot.com":
			case "app-us.digiexam.com":
				region = "usa";
				break;
			case "digiexam-demo.appspot.com":
				region = "demo";
				break;
			case "digiexam-manual.appspot.com":
				region = "manual";
				break;
			case "digiexam-release.appspot.com":
				region = "release";
				break;
			case "localhost":
				region = "localhost";
				break;
		}

		var locale = "en";
		var languageCookie = $cookies.getObject("language");
		if (languageCookie && languageCookie.locale) {
			locale = languageCookie.locale;
		}

		dxApiV1Session.getToken().then(function openDeepLink(response) {
			if (!response || !response.authToken) {
				return;
			}

			// eslint-disable-next-line no-undef
			var deepLinkUrl = new URL("digiexam://");
			deepLinkUrl.searchParams.set("region", region);
			deepLinkUrl.searchParams.set("token", response.authToken);
			deepLinkUrl.searchParams.set("language", locale);

			$window.location.href = deepLinkUrl.toString();
		});
	};
});
